
export enum Lang {
  FR = 'fr',
  EN = 'en',
  DE = 'de',
  ES = 'es',
  IT = 'it',
  NL = 'nl',
}
